/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_Appear_HereInputs */

const en_disabled_websites_appear_here = /** @type {(inputs: Disabled_Websites_Appear_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Websites you disable will appear here`)
};

const es_disabled_websites_appear_here = /** @type {(inputs: Disabled_Websites_Appear_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los sitios que deshabilites aparecerán aquí`)
};

/**
* | output |
* | --- |
* | "Websites you disable will appear here" |
*
* @param {Disabled_Websites_Appear_HereInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_appear_here = /** @type {((inputs?: Disabled_Websites_Appear_HereInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Appear_HereInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_appear_here(inputs)
	return en_disabled_websites_appear_here(inputs)
});